import { render, staticRenderFns } from "./MDI.vue?vue&type=template&id=49a2b488&scoped=true&"
import script from "./MDI.vue?vue&type=script&lang=js&"
export * from "./MDI.vue?vue&type=script&lang=js&"
import style0 from "./MDI.vue?vue&type=style&index=0&id=49a2b488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2b488",
  null
  
)

export default component.exports